// object template used for add/edit order  orders -> new/edit -> one row of prodict which was bought
export class OneOrderShoppingItem {
    name;
    qty;
    cost;
    total;
    isCustom;


    constructor(_input) {

        if (_input === null || _input === undefined) {
            _input =  {
                name: undefined,
                qty: 1,
                cost: 0,
                total: 0,
                isCustom: false
            };
        }
        this.qty = _input.qty;
        this.cost = _input.cost;
        this.name = _input.name;
        this.total = _input.total;
        this.isCustom = _input.isCustom;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/classes/oneOrderShoppingItem.ts